// Site constants. The brand name, the contact address and the film paths live
// here and nowhere else (vite.config.ts fills index.html from this file).

export const BRAND = 'Overnight';

// Shown under the contact form. It forwards to Nikola's inbox (Cloudflare Email Routing).
export const CONTACT_EMAIL = 'hello@madeovernight.com';
export const CONTACT_EMAIL_IS_PLACEHOLDER = false;

// The one call to action on the page; it scrolls to the contact block.
export const CTA_LABEL = 'Get a quote for your next film';

// The case film (script v3, 72 seconds). To swap it, replace the file in
// public/video/ and, if the name changes, this path.
export const CASE_FILM = {
  src: '/video/case-film.mp4',
  poster: '/video/case-film-poster.jpg',
  length: '1:12',
};

// The public address of the site, no trailing slash. Link previews use it.
export const SITE_URL = 'https://madeovernight.com';

export const SITE_TITLE = `${BRAND}: finished documentary films for YouTube channels`;
export const SITE_DESCRIPTION =
  'Send a recorded voiceover and a script. Get back a finished documentary in your channel’s style, as an Adobe Premiere Pro project you can still edit plus a master file.';
export const OG_IMAGE = '/og.jpg';

// The contact form posts here (a Cloudflare Worker route, see worker/index.js).
export const CONTACT_ENDPOINT = '/api/contact';

// The two finished films. They play from our own storage (an HLS stream under
// /video/films/, see worker/upload-films.mjs), because the YouTube embed asks
// some visitors to sign in before it plays. The YouTube id is kept for the link.
export const FILMS = {
  europe: { id: '0XReMasQmcc', title: 'Europe Has a Problem', stream: '/video/films/europe/index.m3u8' },
  trolls: { id: 'SKwToyqAUeM', title: 'Social Media and Power', stream: '/video/films/trolls/index.m3u8' },
};
